import { render, staticRenderFns } from "./selectedItemsForm.vue?vue&type=template&id=0796a523&lang=pug&"
import script from "./selectedItemsForm.vue?vue&type=script&lang=js&"
export * from "./selectedItemsForm.vue?vue&type=script&lang=js&"
import style0 from "./selectedItemsForm.vue?vue&type=style&index=0&id=0796a523&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports